import { ID_DATA } from '~/js/constants/data-element-ids'
import { pushCartAddedEvent } from '~/js/gtm'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import axios from 'axios'

let processing = false
let oc_data = null

export const initProductPage = () => {
  $(document).on('submit', '.product__form[action="/cart/add"]', async (e) => {
    e.preventDefault()
    if (!$('#oc-variant-id').val()) return

    if (!processing) {
      processing = true
      const $this = $(e.currentTarget)
      const serializeForm = $this.serializeArray()

      let variant_id = serializeForm.find((x) => x.name == 'id').value

      let quantity = serializeForm.find((x) => x.name == 'product-quantity')
        ? serializeForm.find((x) => x.name == 'product-quantity').value
        : ''
      let product_title = serializeForm.find((x) => x.name == 'product-title')
        ? serializeForm.find((x) => x.name == 'product-title').value
        : ''
      let product_image = serializeForm.find((x) => x.name == 'product-image')
        ? serializeForm.find((x) => x.name == 'product-image').value
        : ''
      let purchaseLimit = e.currentTarget.querySelector(
        '[name=product-quantity]'
      )
        ? e.currentTarget.querySelector('[name=product-quantity]').dataset.limit
        : ''

      let quantity_to_add = Number(quantity)
      processing = false

      if (purchaseLimit) {
        // alert
        let cart = null
        try {
          cart = await $.get('/cart.js', null, null, 'json')
        } catch (e) {
          processing = false
          return false
        }
        const itemFound = cart.items.find((i) => i.id == variant_id)
        const totalQuantity = itemFound
          ? Number(itemFound.quantity) + Number(quantity)
          : Number(quantity)
        if (totalQuantity > purchaseLimit) {
          alert(
            '1回の注文で購入できる上限数を超えている商品がございますので、数量をご確認ください。'
          )
          processing = false
          return
        }
      }

      let form_data = {
        id: variant_id,
        quantity: quantity,
      }

      const oc_qty = serializeForm.find((x) => x.name == 'oc-qty').value
      const windows = serializeForm.find(
        (x) => x.name == 'oc-qty-windows'
      ).value
      form_data = {
        id: serializeForm.find((x) => x.name == 'oc-variant-id').value,
        quantity: oc_qty,
        properties: {
          窓のタイプ: serializeForm.find((x) => x.name == 'oc-window-type')
            .value,
          スタイル: serializeForm.find((x) => x.name == 'oc-header').value,
          開き方: serializeForm.find((x) => x.name == 'oc-opening').value,
          _採寸幅: serializeForm.find((x) => x.name == 'oc-width').value,
          _採寸丈: serializeForm.find((x) => x.name == 'oc-height').value,
          仕上がり幅: serializeForm.find((x) => x.name == 'oc-final-width')
            .value,
          仕上がり丈: serializeForm.find((x) => x.name == 'oc-final-height')
            .value,
          フックタイプ: serializeForm.find((x) => x.name == 'oc-fork-type')
            .value,
          _調整丈: serializeForm.find((x) => x.name == 'oc-elevation').value,
          _有料オプション: serializeForm.find((x) => x.name == 'oc-option')
            .value,
          窓数: windows,
          枚数: oc_qty,
          _縫製場所: serializeForm.find((x) => x.name == 'oc-location').value,
          _opt_ref: serializeForm.find((x) => x.name == 'oc-option-variant')
            .value,
          _カラーコード: serializeForm.find((x) => x.name == 'oc-color').value,
        },
      }

      let accessories = []
      const add_option = serializeForm.find(
        (x) => x.name == 'oc-option-variant'
      ).value
      if (add_option.length > 0) {
        const main_prod = form_data
        form_data = {
          items: [],
        }
        const options = add_option.split(',')
        for (const option in options) {
          const item = options[option].trim().split(':')
          form_data['items'].push({
            id: item[1],
            quantity: oc_qty,
          })
          accessories.push({
            product_id: item[0],
            id: item[1],
            handle: item[2],
            quantity: oc_qty,
          })
        }
        form_data['items'].push(main_prod) // Set main product to be first on the list of cart page.
      }

      const customer = serializeForm.find(
        (x) => x.name == 'oc-customer-id'
      ).value
      if (customer) {
        oc_data = {
          customer: customer,
          order: {
            product_handle: serializeForm.find(
              (x) => x.name == 'oc-product-handle'
            ).value,
            product_title: serializeForm.find((x) => x.name == 'product-title')
              .value,
            product_id: serializeForm.find((x) => x.name == 'oc-product-id')
              .value,
            vendor: serializeForm.find((x) => x.name == 'oc-vendor').value,
            color: serializeForm.find((x) => x.name == 'oc-color').value,
            windows: windows,
            curtains: oc_qty,
            data: form_data,
            accessories: accessories,
          },
        }
      }

      const oc_modal = $('#modal_agreement')
      if (oc_modal.length && !oc_modal.prop('checked')) {
        return
      }
      $.ajax({
        url: $this.attr('action'),
        type: 'post',
        data: form_data,
      })
        .done(() => {
          if (oc_modal.length && oc_modal.prop('checked')) {
            alert(
              'カートに商品が入りました。カート内で数量変更できませんので、ご購入前にカートの内容をご確認ください。'
            )
            window.location.href = $('.oc.modal-store-close').attr('href')
          }

          const data = $this.data()
          const items = [
            {
              productTitle: product_title,
              image: product_image,
              addedQuantity: quantity_to_add,
              category: data.category,
              id: data.product.id,
              price: data.product.price / 100,
              productType: data.product.type,
              quantity,
              variant: variant_id,
              vendor: data.product.vendor,
            },
          ]

          window.dispatchEvent(
            new CustomEvent('cart-added', {
              detail: { items },
            })
          )
          pushCartAddedEvent({ items })
        })
        .fail((_) => {
          processing = false
          alert('在庫切れです。')
        })
    }
  })

  function closeModal(e) {
    e.preventDefault()
    e.stopPropagation()
    $.magnificPopup.close()
  }

  function openModal(content) {
    $.magnificPopup.open({
      items: {
        src: content,
      },
      showCloseBtn: false,
      closeOnBgClick: true,
      type: 'inline',
    })
  }

  async function saveQuote(events) {
    if (!oc_data) return

    const element = document.getElementById(ID_DATA)
    if (!element) return

    const h = element.dataset.hashedCustomerId
    const edit_session = sessionStorage.getItem(
      `oc_edit_${oc_data.order.product_id}`
    )
    const form_data = {
      id: JSON.parse(edit_session || '{}').c_quote_id,
      customerId: parseFloat(oc_data.customer),
      h,
    }

    let main_product = null
    if (oc_data.order.data.items) {
      oc_data.order.data.items.forEach((item) => {
        if (item.properties) {
          main_product = item
        }
      })
    } else {
      main_product = oc_data.order.data
    }

    if (main_product) {
      const item = {
        accessories: [],
      }
      // Main Product
      item.productId = parseFloat(oc_data.order.product_id)
      item.variantId = parseFloat(main_product.id)
      item.handle = oc_data.order.product_handle
      item.manufacturer = oc_data.order.vendor
      item.pos = 0
      item.fabricName = oc_data.order.product_title
      item.color = oc_data.order.color
      item.windowType = main_product.properties['窓のタイプ']
      item.hookType = main_product.properties['フックタイプ']
      item.curtainStyle = main_product.properties['スタイル']
      item.openingType = main_product.properties['開き方']
      item.widthCustomerMeasured = parseFloat(
        main_product.properties['_採寸幅']
      )
      item.heightCustomerMeasured = parseFloat(
        main_product.properties['_採寸丈']
      )
      item.width = parseFloat(main_product.properties['仕上がり幅'])
      item.height = parseFloat(main_product.properties['仕上がり丈'])
      item.length = parseFloat(main_product.properties['_調整丈'])
      item.windows = parseFloat(main_product.properties['窓数'])
      item.curtains = parseFloat(main_product.properties['枚数'])

      oc_data.order.accessories.forEach((accessory) => {
        item.accessories.push({
          productId: parseFloat(accessory.product_id),
          variantId: parseFloat(accessory.id),
          handle: accessory.handle,
          fabricName: accessory.handle.replace('nt', '').replace('se', ''),
        })
      })

      form_data.quotation = item
    }

    try {
      await axios.post(
        `${baseUrlFrontApi}/customers/order_curtain_quotation/upsert`,
        form_data
      )
      $('#order-curtain-btn').prop('disabled', false)
      alert('お見積書を保存しました。')
      closeModal(events)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  function submitForm() {
    $('.product__form').trigger('submit')
  }

  const saveOrderCurtainQuoteButton = $('#save-order-curtain-btn')
  const addOrderCurtainToCartButton = $(
    '#modal_order_curtain_confirm.oc_modal .modal-store-close'
  )

  function disableButtonsInOrderCurtainModal() {
    saveOrderCurtainQuoteButton.attr('disabled', true)
    addOrderCurtainToCartButton.attr('disabled', true)
  }

  $(function () {
    //Change max-width of content on product detail page if additional shogun content exists
    if ($('.shogun-root')[0]) {
      // change max width to 100% if shogun class exists
      $('.product-description').addClass('shogun-product-details-content')
    }

    $('#store_list_info .popup__actions .btn-close').on('click', (e) => {
      closeModal(e)
    })

    $('#product_features_info .popup__actions .btn-close').on('click', (e) => {
      closeModal(e)
    })

    $(document).on('click', '.prd_features .ico-info', () => {
      openModal('#product_features_info')
    })

    $(document).on('click', '#about_stores_btn', () => {
      openModal('#store_list_info')
    })

    $(document).on('click', '#order-curtain-btn', () => {
      if ($('#cc_agreement').is(':checked')) {
        $('#order-curtain-btn').prop('disabled', false)
        $('#modal_agreement').prop('checked', false)
        submitForm()
        openModal('#modal_order_curtain_confirm')
      } else {
        alert('注意事項を確認してください')
      }
    })

    saveOrderCurtainQuoteButton.one('click', function (e) {
      saveQuote(e)
      disableButtonsInOrderCurtainModal()
    })

    $(document).on('click', '#close-oc-modal', (e) => {
      closeModal(e)
      $('#modal_agreement').prop('checked', false)
      disableButtonsInOrderCurtainModal()
    })

    addOrderCurtainToCartButton.one('click', function (e) {
      e.preventDefault()
      submitForm()
    })

    $(document).on('change', '#modal_agreement', function () {
      if ($(this).is(':checked')) {
        saveOrderCurtainQuoteButton.removeAttr('disabled')
        if (addOrderCurtainToCartButton.attr('data-out-of-stock') === 'false') {
          addOrderCurtainToCartButton.removeAttr('disabled')
        }
      } else {
        disableButtonsInOrderCurtainModal()
      }
    })
  })
}
